import { MutationFunction, useMutation, UseMutationOptions, UseMutationResult } from "react-query";
import { ProblemResponse } from "./ProblemResponse";
import { Response } from "./Response";

export const useHTTPMutation = <T, U>(
	mutFunc: MutationFunction<Response<T>, U>,
	options?: UseMutationOptions<Response<T>, ProblemResponse, U>
): UseMutationResult<Response<T>, ProblemResponse, U> => useMutation(mutFunc, options);
